import type { FunctionComponent, SVGProps } from 'react';

export type DottedOutlineCircleProps = SVGProps<SVGSVGElement> & {
    readonly className?: string;
    readonly fill?: string;
    readonly height?: number | string;
    readonly width?: number | string;
};

export const DottedOutlineCircleIcon: FunctionComponent<DottedOutlineCircleProps> = ({
    className = '',
    height = 16,
    width = 16,
    ...props
}) => {
    return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
        <svg
            className={className}
            fill="none"
            height={height}
            viewBox="0 0 11 10"
            width={width}
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx="5.66663" cy="5" r="4.5" stroke="currentColor" strokeDasharray="2 2" />
        </svg>
    );
};
